var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXiazaiMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.138 11.368a.2.2 0 01-.276 0L2.61 6.345A.2.2 0 012.748 6h10.504a.2.2 0 01.138.345l-5.252 5.023z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.2c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2V6h-5V1.2zM2.5 13.2c0-.11.09-.2.2-.2h10.6c.11 0 .2.09.2.2v1.1a.2.2 0 01-.2.2H2.7a.2.2 0 01-.2-.2v-1.1z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xiazai_mian.1eee94d1.svg";
export { SvgTongyongXiazaiMian as ReactComponent };